<template>
    <div>
        <div v-if="!editMode">
            <label class="hh-input-label">Date of birth</label>
            <span class="form-control overflow-x form-color">
                {{displayValue}}
            </span>
        </div>

        <div v-else class="hh-input-label-wrapper">
        <label for="month" v-if="withLabel || !enabled" @click="enableFormDate" class="hh-input-label">Date of birth</label>
            <div class="FormDate form-control"
                 @keyup.capture="updateValue"
                 @blur="disableFormDate"
                 :class="withLabel && enabled ? 'hh-label-active' : ''"
            >
                <div class="form-date-wrapper">
                    <input
                            v-if="showMonth"
                            ref="month"
                            id="month"
                            v-model="month"
                            class="FormDate__input FormDate__input--month"
                            type="number"
                            placeholder="MM"
                            @input="updateMonth"
                    >
                    <span
                            v-if="showDay && showMonth"
                            class="FormDate__divider"
                    >/</span>
                    <input
                            v-if="showDay"
                            ref="day"
                            v-model="day"
                            class="FormDate__input FormDate__input--day"
                            type="number"
                            placeholder="DD"
                            @input="updateDay"
                    >
                    <span
                            v-if="showYear && (showDay || showMonth)"
                            class="FormDate__divider"
                    >/</span>
                    <input
                            v-if="showYear"
                            ref="year"
                            v-model="year"
                            class="FormDate__input FormDate__input--year"
                            type="number"
                            placeholder="YYYY"
                    >
                </div>
            </div>
            
        </div>

        <div v-if="editMode">
            <div class="invalid-feedback-red" v-if="errors">
                {{errors}}
            </div>
            <div class="invalid-feedback-red" v-show="!isDateValid">
                This date is not valid
            </div>
        </div>
    </div>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    name: 'FormDate',
    props: {
      value: {
        type: [Number, String],
      },
      showDay: {
        type: Boolean,
        default: true,
      },
      showMonth: {
        type: Boolean,
        default: true,
      },
      showYear: {
        type: Boolean,
        default: true,
      },
      withLabel: {
        type: Boolean,
        default: true,
      },
      errors: String,
      editMode: Boolean,
      role: String,
    },

    beforeMount () {
      if (!_.isEmpty(this.value)) {
        let date = new Date(Date.parse(this.value))

        this.stringDate = dayjs(this.value).format('D MMM YYYY')

        this.year = '' + date.getFullYear()
        this.month = '' + date.getMonth() + 1
        this.day = '' + date.getDate()

        this.enabled = true
      }
    },

    data () {
      return {
        enabled: false,
        isDateValid: true,
        stringDate: null,
        resultDate: null,
        day: null,
        month: null,
        year: null,
      }
    },
    watch: {
      year (current, prev) {
        if (current > 9999) this.year = prev
      },
      day (current, prev) {
        if (current > 31) this.day = prev
      },
      isDateValid (to, from) {
        this.$emit('setStatus', to)
      },
    },
    methods: {
      disableFormDate () {
        this.enabled = !_.isEmpty(this.day)
      },
      enableFormDate () {
        this.enabled = true
        this.$refs.month.select()
      },
      updateDay () {
        if (!this.day.length || parseInt(this.day, 10) < 4) return
        if (this.showYear) this.$refs.year.select()
      },
      updateMonth () {
        if (!this.month.length || parseInt(this.month, 10) < 2) return
        if (this.showDay) this.$refs.day.select()
        else if (this.showYear) this.$refs.year.select()
      },
      updateValue () {
        let parsedDate = new Date(Date.parse(`${this.year}-${this.month}-${this.day}`))

        let maximDate = new Date()
        let minimumDate = new Date()
        let currentDate = new Date()

        let minYear = currentDate.getFullYear() - 120
        let maxYear = currentDate.getFullYear() - 18

        maximDate.setFullYear(currentDate.getFullYear() - 18)
        minimumDate.setFullYear(currentDate.getFullYear() - 120)

        if (_.isEmpty(this.day)
                || _.isEmpty(this.month)
                || _.isEmpty(this.year)
                || !_.isDate(parsedDate)
                || isNaN(parsedDate.getTime())
                || parsedDate > maximDate
                || parsedDate < minimumDate
                || this.year > maxYear
                || this.year < minYear ){
          this.isDateValid = false
          return
        }

        this.resultDate = parsedDate.toDateString()
        this.isDateValid = true
        this.$emit(`input`, this.resultDate)
      },
    },
    computed: {
      displayValue () {
        if (!_.isEmpty(this.stringDate)) {
          return this.stringDate
        }

        return ''
      },
    },

  }
</script>

<style lang="scss">
    .FormDate {
        $spacing: 0.6em;

        display: inline-flex;
        position: relative;
        overflow: hidden;
        border-radius: 0.25em;
        height: 55px !important;

        .placeholder-label {
            width: 100%;
            color: #b1b7ba;
            font-weight: normal;
        }

        .form-date-wrapper {
            align-items: center;
            display: block !important; 
            margin-top: -5px;
        }

        div.form-control {
          height: 55px;
        }

        span.form-control {
          height: 55px; padding: 15px; font-family: Circular Std;
          font-style: normal;
          font-weight: 450;
          font-size: 15px;
          line-height: 19px; 
          color: #4a4a4a;      
        }

        // 1. Hide the spinner button in Chrome, Safari and Firefox.
        &__input {
            padding: $spacing;
            padding-right: $spacing / 2;
            padding-left: $spacing / 2;
            border: none;
            text-align: center;
            /* stylelint-disable-next-line property-no-vendor-prefix */
            -moz-appearance: textfield; // 1

            &::-webkit-inner-spin-button {
                display: none; // 1
            }

            &:first-child {
                padding-left: $spacing;
            }

            &:last-child {
                padding-right: $spacing;
            }

            &:focus {
                outline: none;
            }

            &--day,
            &--month {
                width: 3em;
            }

            &--year {
                width: 4em;
            }
        }

        &__divider {
            padding: $spacing;
            pointer-events: none;
        }
    }
</style>